export enum UndoRedoContextDispatchActionType {
	Undo,
	Redo,
	Set,
	Save,
	Clear,
}
